import { Col, Text, Button, Row, useRequireAuth, LoginForm } from 'components';
import React, { useState, useEffect } from 'react';
import { IScreen } from 'type';
import apiClient from 'store/api-client';

const JOBS = [
  { name: 'Sync Approved Buying List', key: 'sync-approved-buying-list-job' },
  { name: 'Sync Price List Catalogs', key: 'sync-price-list-catalogs-job' },
  { name: 'Sync Shopify Customer', key: 'sync-shopify-customer-job' },
  { name: 'Sync BC Customer', key: 'sync-bc-customer-job' },
  { name: 'Sync Product Budget Category (paused — BC/DB)', key: 'sync-product-budget-category-job' },
  { name: 'Sync Shopify Catalogs (Prices → DB)', key: 'sync-shopify-catalogs-job' },
]

const CronJobStatus: IScreen = () => {
  const { isLoggedIn } = useRequireAuth();
  const [jobs, setJobs] = useState([]);
  const [viewingLogs, setViewingLogs] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const fetchCronJobsStatus = async () => {
    const res = await apiClient.Api.System.cronJobsStatus();
    setJobs(JOBS.map(i => {
      const job = res.data.find(j => j.name === i.key);
      if (!job) return null;
      const data = JSON.parse(job.data);
      return {
        ...job,
        ...i,
        data,
      }
    }).filter(Boolean));
  };

  useEffect(() => {
    if (!isLoggedIn) return;

    fetchCronJobsStatus();

    const interval = setInterval(() => {
      fetchCronJobsStatus();
    }, 60000);

    return () => clearInterval(interval);
  }, [isLoggedIn]);

  const onPressRunNow = async (key: string) => {
    setIsLoading(true);
    // Check if any job is currently running
    const res = await apiClient.Api.System.cronJobsStatus();
    const isAnyJobRunning = res.data.some(job => job.field1 === "running" && job.name === key);
    if (isAnyJobRunning) {
      alert("Another job is currently running. Please wait for it to complete.");
      setIsLoading(false);
      return;
    }
    await apiClient.Api.System.triggerCronJobs({ jobName: key });
    setTimeout(() => {
      fetchCronJobsStatus();
      setIsLoading(false);
    }, 500);
  }

  const onPressViewLogs = async (key: string) => {
    setViewingLogs(key);
  }

  if (!isLoggedIn) {
    return (
      <LoginForm
        title="Login Required"
        description="Please login to access the System Process Status"
      />
    );
  }

  return (
    <Col flex1 p4 backgroundColor="black">
      <Text h2 color="white" mb4>System Process Status</Text>

      <Col>
        {jobs.map((job) => {
          const isRunning = job.field1 === "running";
          return (
            <Col key={job.key} p2 round1 backgroundColor="#222222" mb2>
              <Col row alignItems="center" justifyContent="space-between">
                <Col>
                  <Text color="white" bold mb2>{job.name}</Text>
                  <Text color="#888888" small mb1>Last run: {job?.data?.lastStart}</Text>
                  <Text color={isRunning ? "#ff9900" : "#00ff00"}>{job.field1}</Text>
                </Col>
                <Row>
                  {!!job?.data?.logUrls?.length && (
                    <Button
                      text="View Logs"
                      onPress={() => onPressViewLogs(job.key)}
                      backgroundColor="#444444"
                      mr1
                    />
                  )}
                  <Button
                    text={isRunning ? "Running..." : "Run Now"}
                    disabled={isRunning || isLoading}
                    opacity={isRunning || isLoading ? 0.5 : 1}
                    onPress={() => onPressRunNow(job.key)}
                    backgroundColor="#0066cc"
                  />
                </Row>
              </Col>
              {viewingLogs === job.key && (
                <Col mt2>
                  {job?.data?.logUrls?.map(url => (
                    <a key={url} href={url} target="_blank" rel="noopener noreferrer" style={{ color: 'white', marginBottom: 4 }}>
                      {url}
                    </a>
                  ))}
                </Col>
              )}
            </Col>
          )
        })}
      </Col>
    </Col>
  )
};

CronJobStatus.routeInfo = {
  title: 'MSupply - Cron Job Status',
  path: '/system/cron-job-status',
};

export default CronJobStatus;
